import { render, staticRenderFns } from "./PayBill.vue?vue&type=template&id=4870c802&scoped=true"
import script from "./PayBill.vue?vue&type=script&lang=js"
export * from "./PayBill.vue?vue&type=script&lang=js"
import style0 from "./PayBill.vue?vue&type=style&index=0&id=4870c802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4870c802",
  null
  
)

export default component.exports